import { CricketAPIResponse } from "../types/cricket-update-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export const getCricketUpdates = async (): Promise<IResponse<CricketAPIResponse[]>> => {
  const response = await request<CricketAPIResponse[]>({
    method: "GET",
    url: API_PATHS.cricketUpdate,
  });
  return response;
};
